import React from 'react';
import { CalendarIcon, MapPinIcon } from '@heroicons/react/24/outline';

import { formatEventDate } from '@dashboard/lib/format-date';

export default function EventWhenWhere({ eventDetails }) {
  if (!eventDetails) return null;
  return (
    <>
      {eventDetails.startDate && (
        <div className="flex items-center gap-x-2 justify-start">
          <div>
            <CalendarIcon className="h-5 w-5" />
          </div>
          <div className="flex flex-col font-medium">
            {formatEventDate({
              startDate: eventDetails.startDate,
              endDate: eventDetails.endDate,
              timezone: eventDetails.timezone,
            }).map(date => (
              <span key={date}>{date}</span>
            ))}
          </div>
        </div>
      )}

      {eventDetails.location && (
        <div className="flex items-center gap-x-2 justify-start">
          <div>
            <MapPinIcon className="h-5 w-5" />
          </div>
          {eventDetails.mapsLink && (
            <a
              href={eventDetails.mapsLink}
              target="_blank"
              rel="nofollow noreferrer"
              className="font-medium underline"
            >
              {eventDetails.location}
            </a>
          )}

          {!eventDetails.mapsLink && <span className="font-medium">{eventDetails.location}</span>}
        </div>
      )}
    </>
  );
}
